import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import UserGrid from "./components/UserGrids";

export default function LoginPage() {
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("access_token");
    if (!token) return;
    const role = sessionStorage.getItem("userLoginTab");
    navigate(role === "burdenOwner" ? "/owner/dashboard" : "/driver/dashboard", {
      replace: true,
    });
  }, [navigate]);

  return <UserGrid />;
}
